import React, { useEffect, useState } from 'react';
import Helper from '../../../Dialog/Helper';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../store';
import { MenuState } from '../../../../store/reducers/menuReducer';
import { PrefState } from '../../../../store/reducers/prefReducer';
import UserService from '../../../../services/HeyHoUserService/HeyHoUserService';

interface Props {
    user: any
}

const HelperComponent: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const userService = new UserService(props);

    useEffect(() => {
        if (menu.showHelper) {
            initReducers();
        }
    }, [menu.showHelper]);

    useEffect(() => {
        if (props.user.id && window.screen.width > 600) {
            const getHelper = async () => {
                try {
                    const response = await userService.GetHelperStatusByUserId(Number(props.user.id));

                    if (response) {
                        if (document.location.pathname === '/' && (response.data == null || !response.data.helperStatusSolicitation)) {
                            setTimeout(() => {
                                dispatch({ type: 'MENU_HELPER_VISIBLE', payload: true });
                            }, 3000);
                        }
                        else if (document.location.pathname === '/Attendance' && (response.data == null || !response.data.helperStatusAttendant)) {
                            setTimeout(() => {
                                dispatch({ type: 'MENU_HELPER_VISIBLE', payload: true });
                            }, 3000);
                        }
                    }
                }
                catch (error) {
                    debugger
                }
            }

            getHelper();
        }
    }, [props.user]);

    const solicitationHelperList = [
        {
            top: 85,
            left: 107,
            width: "32px",
            height: "32px",
            name: "Abertura de solicitação rápida",
            description: "Abertura de novas solicitações",
            hand: {
                top: 115,
                left: 140,
                rotate: -45
            }
        },
        {
            top: 85,
            left: 127,
            width: "240px",
            height: "150px",
            name: "Abertura através de template",
            description: "Abertura de novas solicitações usando template",
            hand: {
                top: 235,
                left: 250,
                rotate: 0
            },
            onShow: () => {
                const openTemplates = pref.dataLocal?.openTemplates ?? false;
                if (!openTemplates) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openTemplates", value: true } });
            },
            onHide: () => {
                const openTemplates = pref.dataLocal?.openTemplates ?? false;
                if (openTemplates) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openTemplates", value: false } });
            }
        },
        {
            top: 90,
            left: 107,
            width: "100px",
            height: "100px",
            name: "Abertura através de cópia",
            description: "Abertura de novas solicitações usando cópia de um chamado já criado",
            hand: {
                top: 165,
                left: 150,
                rotate: -45
            }
        },
        {
            top: 90,
            left: 107,
            width: "100px",
            height: "100px",
            name: "Abertura através de cópia",
            description: "Abertura de novas solicitações usando cópia de um chamado já criado",
            hand: {
                top: 95,
                left: 200,
                rotate: -90
            },
            onShow: () => {
                const openModalPref = pref.dataLocal?.openModalPref ?? false;
                if (openModalPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPref", value: false } });
            },
        },
        {
            top: 0,
            left: 80,
            width: (window.innerWidth - 80) + "px",
            height: window.innerHeight + "px",
            name: "Tela de abertura de solicitação",
            description: "",
            onShow: () => {
                const openModalPref = pref.dataLocal?.openModalPref ?? false;
                if (!openModalPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPref", value: true } });
            },
        },
        {
            top: 70,
            left: 0,
            width: "36rem",
            height: "85px",
            styleWindow: {
                margin: "0px calc(50% - 260px)"
            } as React.CSSProperties,
            styleHand: {
                margin: "0px calc(50% + 180px)"
            } as React.CSSProperties,
            name: "Tela de abertura de solicitação",
            description: "Você pode usar a busca rápida para encontrar o que deseja do catálogo de serviços",
            hand: {
                top: 150,
                left: 140,
                rotate: -45
            },
            onShow: () => {
                let sidemodaldiv = document.getElementsByClassName('side-modal visible');
                sidemodaldiv[0] && sidemodaldiv[0].scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            },
        },
        {
            top: 162,
            right: 40,
            width: "calc(45vw + 60px)",
            height: "260px",
            name: "Tela de abertura de solicitação",
            description: "Ou preencher os campos conforme o catálogo de serviços",
            hand: {
                top: 425,
                left: 875,
                rotate: 0
            },
            onShow: () => {
                const openModalPref = pref.dataLocal?.openModalPref ?? false;
                if (!openModalPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPref", value: true } });

                let sidemodaldiv = document.getElementsByClassName('side-modal visible');
                sidemodaldiv[0] && sidemodaldiv[0].scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }
        },
        {
            top: 257,
            right: 40,
            width: "calc(23vw + 15px)",
            height: "80px",
            name: "Tela de abertura de solicitação",
            description: "Se você fizer parte de um grupo de solicitante, é possível acompanhar os tickets do seu grupo",
            hand: {
                top: 255,
                left: window.innerWidth - 130,
                rotate: -180
            },
            onShow: () => {
                const openModalPref = pref.dataLocal?.openModalPref ?? false;
                if (!openModalPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPref", value: true } });
            },
            onHide: () => {
                const openModalPref = pref.dataLocal?.openModalPref ?? false;
                if (openModalPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPref", value: false } });
            },
        },
        {
            top: 0,
            left: window.innerWidth - 562,
            width: (window.innerWidth - 80) + "px",
            height: window.innerHeight + "px",
            name: "Propriedades do chamado",
            description: "",
            onShow: () => {
                const openModalPref = pref.dataLocal?.openModalPref ?? false;
                if (openModalPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPref", value: false } });

                const openModalPropPref = pref.dataLocal?.openModalPropPref ?? false;
                if (!openModalPropPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPropPref", value: true } });
            }
        },
        {
            top: window.innerHeight - 400,
            right: 0,
            width: "560px",
            height: "360px",
            name: "Adicionando anexos",
            description: "Você consegue adicionar uma imagem nos comentários",
            hand: {
                top: window.innerHeight - 100,
                left: window.innerWidth - 280,
                rotate: 110
            },
            onShow: () => {
                let sidemodaldiv = document.getElementsByClassName('side-modalDetails visible');
                sidemodaldiv && sidemodaldiv[0].scrollTo({ top: 500, left: 0, behavior: 'smooth' });
            }
        },
        {
            top: window.innerHeight - 50,
            right: 0,
            width: "560px",
            height: "50px",
            name: "Adicionando anexos",
            description: "Clicando no clipe ou no arrastando para o campo de texto dos comentários",
            hand: {
                top: window.innerHeight - 50,
                left: window.innerWidth - 330,
                rotate: 180
            },
            onShow: () => {
                const openModalPropPref = pref.dataLocal?.openModalPropPref ?? false;
                if (!openModalPropPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPropPref", value: true } });

            },
        },
        {
            top: window.innerHeight - 50,
            right: 0,
            width: "560px",
            height: "50px",
            name: "Adicionando anexos",
            description: "Clicando no clipe ou no arrastando para o campo de texto dos comentários",
            hand: {
                top: window.innerHeight - 25,
                left: window.innerWidth - 500,
                rotate: 45
            },
            onShow: () => {
                const openModalPropPref = pref.dataLocal?.openModalPropPref ?? false;
                if (!openModalPropPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPropPref", value: true } });

            },
            onHide: () => {
                const openModalPropPref = pref.dataLocal?.openModalPropPref ?? false;
                if (openModalPropPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPropPref", value: false } });
            }
        },
        {
            top: 15,
            left: 94,
            width: "300px",
            height: "555px",
            name: "Filtros portal do solicitante",
            description: "Selecione o período que deseja para visualizar os chamados. \nE ainda tem a opção de filtrar por chamados com pendência de avaliação (pesquisa de satisfação)",
            hand: {
                top: 115,
                left: 395,
                rotate: -45
            },
            onShow: () => {
                const openModalPeriodFilters = pref.dataLocal?.openModalPeriodFilters ?? false;
                if (!openModalPeriodFilters) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPeriodFilters", value: true } });
            },
            onHide: () => {
                const openModalPeriodFilters = pref.dataLocal?.openModalPeriodFilters ?? false;
                if (openModalPeriodFilters) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPeriodFilters", value: false } });
            }
        },
        {
            top: 80,
            left: 269,
            width: "45px",
            height: "45px",
            name: "Filtros portal do solicitante - Busca rápida",
            description: "Clique no ícone indicado para pesquisar por número da solicitação ou assunto da solicitação",
            hand: {
                top: 115,
                left: 270,
                rotate: 105
            }
        },
        {
            top: 86,
            left: 360,
            width: "550px",
            height: "108px",
            name: "Filtros portal do solicitante",
            description: "Pesquise por número da solicitação ou palavras que estejam no campo assunto",
            hand: {
                top: 115,
                left: 360,
                rotate: 105
            },
            onShow: () => {
                const openClickSearch = pref.dataLocal?.openClickSearch ?? false;
                if (!openClickSearch) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openClickSearch", value: true } });
            },
            onHide: () => {
                const openClickSearch = pref.dataLocal?.openClickSearch ?? false;
                if (openClickSearch) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openClickSearch", value: false } });
            }
        },
        {
            top: 20,
            right: 120,
            width: "45px",
            height: "45px",
            name: "Últimos comentários",
            description: "Clique para consultar os últimos comentários de chamados que você como solicitante possui acesso",
            hand: {
                top: 45,
                left: window.innerWidth - 150,
                rotate: 90
            },
        },
        {
            top: 0,
            left: window.innerWidth - 562,
            width: (window.innerWidth - 80) + "px",
            height: window.innerHeight + "px",
            name: "Últimos comentários",
            description: "Visualize os últimos comentários",
            onShow: () => {
                const openLastComments = pref.dataLocal?.openLastComments ?? false;
                if (!openLastComments) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openLastComments", value: true } });


            },
            onHide: () => {
                const openLastComments = pref.dataLocal?.openLastComments ?? false;
                if (openLastComments) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openLastComments", value: false } });


            }
        },
        {
            top: 0,
            left: window.innerWidth - 562,
            width: (window.innerWidth - 80) + "px",
            height: window.innerHeight + "px",
            name: "Chamado esperando avaliação",
            description: "Avalie o atendimento clicando sobre as estrelas. Mas lembre-se. Caso você selecione 3 estrelas ou menos, o campo de justificativa torna-se obrigatório",
            hand: {
                top: 325,
                left: window.innerWidth - 384,
                rotate: 50
            },
            onShow: () => {
                const openModalAvaliationPref = pref.dataLocal?.openModalAvaliationPref ?? false;
                if (!openModalAvaliationPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalAvaliationPref", value: true } });

                const openModalPropPref = pref.dataLocal?.openModalPropPref ?? false;
                if (!openModalPropPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPropPref", value: true } });
            },
            onHide: () => {
                const openModalAvaliationPref = pref.dataLocal?.openModalAvaliationPref ?? false;
                if (openModalAvaliationPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalAvaliationPref", value: false } });

                const openModalPropPref = pref.dataLocal?.openModalPropPref ?? false;
                if (openModalPropPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalPropPref", value: false } });
            },
        },
        {
            top: 50,
            right: 30,
            width: "200px",
            height: "175px",
            name: "Ajuda",
            description: "Você pode ver essa ajuda quando quiser",
            hand: {
                top: 75,
                left: window.innerWidth - 235,
                rotate: 50
            },
            onShow: () => {
                const openModalHelpDropdown = pref.dataLocal?.openModalHelpDropdown ?? false;
                if (!openModalHelpDropdown) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalHelpDropdown", value: true } });
            },
            onHide: () => {
                const openModalHelpDropdown = pref.dataLocal?.openModalHelpDropdown ?? false;
                if (openModalHelpDropdown) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalHelpDropdown", value: false } });
            }
        }
    ];

    const attendantHelperList = [
        {
            top: 85,
            left: 98,
            width: "32px",
            height: "32px",
            name: "Abertura de solicitação rápida",
            description: "Abertura de novas solicitações",
            hand: {
                top: 100,
                left: 140,
                rotate: -45
            },
        },
        {
            top: 85,
            left: 115,
            width: "242px",
            height: "175px",
            name: "Abertura através de template",
            description: "Abertura de novas solicitações usando template",
            hand: {
                top: 105,
                left: 150,
                rotate: -135
            },
            onShow: () => {
                const openTemplatesAttPref = pref.dataLocal?.openTemplatesAttPref ?? false;
                if (!openTemplatesAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openTemplatesAttPref", value: true } });
            },
            onHide: () => {
                const openTemplatesAttPref = pref.dataLocal?.openTemplatesAttPref ?? false;
                if (openTemplatesAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openTemplatesAttPref", value: false } });
            }
        },
        {
            top: 90,
            left: 98,
            width: "100px",
            height: "100px",
            name: "Abertura através de cópia",
            description: "Abertura de novas solicitações usando cópia de um chamado já criado",
            hand: {
                top: 165,
                left: 145,
                rotate: -45
            }
        },
        {
            top: 90,
            left: 98,
            width: "100px",
            height: "100px",
            name: "Abertura através de cópia",
            description: "Abertura de novas solicitações usando cópia de um chamado já criado",
            hand: {
                top: 109,
                left: 190,
                rotate: -90
            },
            onShow: () => {
                const openModalAttPref = pref.dataLocal?.openModalAttPref ?? false;
                if (openModalAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalAttPref", value: false } });
            }
        },
        {
            top: 0,
            left: 80,
            width: (window.innerWidth - 80) + "px",
            height: window.innerHeight + "px",
            name: "Tela de abertura de solicitação",
            description: "",
            onShow: () => {
                const openModalAttPref = pref.dataLocal?.openModalAttPref ?? false;
                if (!openModalAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalAttPref", value: true } });
            }
        },
        {
            top: 187,
            left: 110,
            width: "62vw",
            height: "60px",
            name: "Tela de abertura de solicitação",
            description: "Você pode usar a busca rápida para encontrar o que deseja do catálogo de serviços",
            hand: {
                top: 285,
                left: 240,
                rotate: -45
            },
            onShow: () => {
                let sidemodaldiv = document.getElementsByClassName('side-modal visible');
                sidemodaldiv[0] && sidemodaldiv[0].scrollTo({ top: 320, left: 0, behavior: 'smooth' });
            },
        },

        {
            top: 250,
            left: 110,
            width: 'calc(55px + 66vw)',
            height: '235px',
            name: "Tela de abertura de solicitação",
            description: "Ou preencher os campos conforme o catálogo de serviços",
            hand: {
                top: 360,
                left: 150,
                rotate: 0
            },
            onShow: () => {
                // let sidemodaldiv = document.getElementsByClassName('side-modal visible');
                // sidemodaldiv[0] && sidemodaldiv[0].scrollTo({ top: 250, left: 0, behavior: 'smooth' });
            }
        },

        {
            top: 248,
            left: 120,
            width: "165px",
            height: "35px",
            name: "Tela de abertura de solicitação",
            description: "Salvar template das categorias que você mais utiliza",
            hand: {
                top: 315,
                left: 155,
                rotate: 0
            },
            onShow: () => {
                let sidemodaldiv = document.getElementsByClassName('side-modal visible');
                sidemodaldiv[0] && sidemodaldiv[0].scrollTo({ top: 560, left: 0, behavior: 'smooth' });

                const openTooltipAttPref = pref.dataLocal?.openTooltipAttPref ?? false;
                if (openTooltipAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openTooltipAttPref", value: false } });
            }
        },
        {
            top: 180,
            left: "42rem",
            width: "235px",
            height: "450px",
            name: "Tooltip de solicitações",
            description: "Deixando o mouse por alguns segundos em cima das colunas: N° sol, status, SLA/SLO e assunto da solicitação, você tem uma prévia das informações da solicitação",
            hand: {
                top: 220,
                left: "41rem",
                rotate: 90
            },
            onShow: () => {
                const openModalAttPref = pref.dataLocal?.openModalAttPref ?? false;
                if (openModalAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalAttPref", value: false } });

                const openTooltipAttPref = pref.dataLocal?.openTooltipAttPref ?? false;
                if (!openTooltipAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openTooltipAttPref", value: true } });
            },
            // onHide: () => {
            //     const openTooltipAttPref = pref.dataLocal?.openTooltipAttPref ?? false;
            //     if (openTooltipAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openTooltipAttPref", value: false } });
            // }
        },
        {
            top: 180,
            left: "53rem",
            width: "360px",
            height: "150px",
            name: "Tooltip de solicitações",
            description: "Clicando nesta seta, você ainda encontra os últimos comentários",
            hand: {
                top: 200,
                left: "55rem",
                rotate: 145
            },
            onShow: () => {
                const openTooltipCommentsPref = pref.dataLocal?.openTooltipCommentsPref ?? false;
                if (!openTooltipCommentsPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openTooltipCommentsPref", value: true } });
            },
            onHide: () => {
                const openTooltipCommentsPref = pref.dataLocal?.openTooltipCommentsPref ?? false;
                if (openTooltipCommentsPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openTooltipCommentsPref", value: false } });
            }
        },

        {
            top: 145,
            left: 103,
            width: "42px",
            height: "42px",
            name: "Vincular solicitações",
            description: 'Selecione a solicitação para fazer o vínculo com o chamado "pai". Após o vínculo ocorrer, toda ação realizado no chamado pai, irá refletir nos "filhos"',
            hand: {
                top: 190,
                left: 120,
                rotate: 0
            },
            onShow: () => {
                const openTooltipAttPref = pref.dataLocal?.openTooltipAttPref ?? false;
                if (openTooltipAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openTooltipAttPref", value: false } });
            }
        },
        {
            top: 85,
            left: 198,
            width: "32px",
            height: "32px",
            name: "Vincular solicitações",
            description: 'Selecione a solicitação para fazer o vínculo com o chamado "pai". Após o vínculo ocorrer, toda ação realizado no chamado pai, irá refletir nos "filhos"',
            hand: {
                top: 100,
                left: 240,
                rotate: -45
            },
            onShow: () => {
                const openVincularPref = pref.dataLocal?.openVincularPref ?? false;
                if (openVincularPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openVincularPref", value: false } });
            }
        },

        {
            top: 120,
            left: 95,
            width: "calc(100% - 140px)",
            height: "75px",
            name: "Vincular solicitações",
            description: 'Selecione a solicitação para fazer o vínculo com o chamado "pai". Após o vínculo ocorrer, toda ação realizado no chamado pai, irá refletir nos "filhos"',
            hand: {
                top: 200,
                left: "55rem",
                rotate: -35
            },
            onShow: () => {
                const openVincularPref = pref.dataLocal?.openVincularPref ?? false;
                if (!openVincularPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openVincularPref", value: true } });
            }
        },
        {
            top: 145,
            left: "90%",
            width: "42px",
            height: "42px",
            name: "Vincular solicitações",
            description: 'Selecione a solicitação para fazer o vínculo com o chamado "pai". Após o vínculo ocorrer, toda ação realizado no chamado pai, irá refletir nos "filhos"',
            hand: {
                top: 170,
                left: "90%",
                rotate: 90
            },
            onShow: () => {
                const openVincularPref = pref.dataLocal?.openVincularPref ?? false;
                if (!openVincularPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openVincularPref", value: true } });
            }
        },


        {
            top: 85,
            left: 276,
            width: "32px",
            height: "32px",
            name: "Filtros portal de atendente",
            description: 'Filtre os dados necessários',
            hand: {
                top: 120,
                left: 290,
                rotate: -33
            },
            onShow: () => {
                const openVincularPref = pref.dataLocal?.openVincularPref ?? false;
                if (openVincularPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openVincularPref", value: false } });

                const openFiltersAttPref = pref.dataLocal?.openFiltersAttPref ?? false;
                if (openFiltersAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openFiltersAttPref", value: false } });
            }
        },
        {
            top: 120,
            left: 115,
            width: "95%",
            height: "217px",
            name: "Filtros portal de atendente",
            description: "",
            onShow: () => {
                const openFiltersAttPref = pref.dataLocal?.openFiltersAttPref ?? false;
                if (!openFiltersAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openFiltersAttPref", value: true } });
            }
        },

        {
            top: 120,
            left: 115,
            width: "95%",
            height: "275px",
            name: "Filtros portal de atendente",
            description: "Lembre-se de ao final, aplicar o filtro realizado",
            hand: {
                top: 340,
                left: 160,
                rotate: 230
            },

        },
        {
            top: 120,
            left: 115,
            width: "95%",
            height: "275px",
            name: "Filtros portal de atendente",
            description: "Tenha a possibilidade de salvar seu filtro",
            hand: {
                top: 365,
                left: 415,
                rotate: -50
            },
            onShow: () => {
                const openFiltersAttPref = pref.dataLocal?.openFiltersAttPref ?? false;
                if (!openFiltersAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openFiltersAttPref", value: true } });
            },
        },

        {
            top: 77,
            left: 310,
            width: "50px",
            height: "50px",
            name: "Filtros portal do atendente - Busca rápida",
            description: "Clique no ícone indicado para pesquisar por número da solicitação ou assunto da solicitação.",
            hand: {
                top: 115,
                left: 310,
                rotate: 105
            },
            onShow: () => {
                const openFiltersAttPref = pref.dataLocal?.openFiltersAttPref ?? false;
                if (openFiltersAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openFiltersAttPref", value: false } });
            }
        },
        {
            top: 75,
            left: 307,
            width: "600px",
            height: "205px",
            name: "Filtros portal do atendente",
            description: "Pesquise por número da solicitação ou palavras que estejam no campo assunto.",
            hand: {
                top: 115,
                left: 310,
                rotate: 105
            },
            onShow: () => {
                const openClickSearchAttPref = pref.dataLocal?.openClickSearchAttPref ?? false;
                if (!openClickSearchAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openClickSearchAttPref", value: true } });
            },
            onHide: () => {
                const openClickSearchAttPref = pref.dataLocal?.openClickSearchAttPref ?? false;
                if (openClickSearchAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openClickSearchAttPref", value: false } });
            }
        },
        {
            top: 20,
            right: 114,
            width: "50px",
            height: "50px",
            name: "Últimos comentários",
            description: "Clique para consultar os últimos comentários de chamados de você como atendente, possui acesso",
            hand: {
                top: 45,
                left: window.innerWidth - 154,
                rotate: 90
            },
        },
        {
            top: 0,
            left: window.innerWidth - 562,
            width: (window.innerWidth - 80) + "px",
            height: window.innerHeight + "px",
            name: "Últimos comentários",
            description: "Visualize os últimos comentários",
            onShow: () => {
                const openLastComments = pref.dataLocal?.openLastComments ?? false;
                if (!openLastComments) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openLastComments", value: true } });
            },
            onHide: () => {
                const openLastComments = pref.dataLocal?.openLastComments ?? false;
                if (openLastComments) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openLastComments", value: false } });
            }
        },
        {
            top: 85,
            left: 393,
            width: "32px",
            height: "32px",
            name: "Personalizar colunas",
            description: "Neste menu, o atendente consegue personalizar a tabela do portal",
            hand: {
                top: 100,
                left: 430,
                rotate: -45
            }
        },
        {
            top: 105,
            left: 353,
            width: "228px",
            height: "282px",
            name: "Personalizar colunas",
            description: "Neste menu, o atendente consegue personalizar a tabela do portal",
            hand: {
                top: 180,
                left: 595,
                rotate: -135
            },
            onShow: () => {
                const openMenuOptionsAttPref = pref.dataLocal?.openMenuOptionsAttPref ?? false;
                if (!openMenuOptionsAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openMenuOptionsAttPref", value: true } });
            },
            onHide: () => {
                const openMenuOptionsAttPref = pref.dataLocal?.openMenuOptionsAttPref ?? false;
                if (openMenuOptionsAttPref) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openMenuOptionsAttPref", value: false } });
            }
        },
        {
            top: 25,
            right: 163,            
            width: "32px",
            height: "32px",
            name: "Tela cheia",
            description: "Clique no icone indicado para ativar a visualização em tela cheia",
            hand: {
                top: 49,
                left: window.innerWidth - 186,
                rotate: 90
            }
        },
        {
            top: 55,
            right: 35,
            width: "190px",
            height: "70px",
            name: "Ajuda",
            description: "Você pode ver essa ajuda quando quiser",
            hand: {
                top: 45,
                left: window.innerWidth - 215,
                rotate: 90
            },
            onShow: () => {
                const openModalHelpDropdown = pref.dataLocal?.openModalHelpDropdown ?? false;
                if (!openModalHelpDropdown) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalHelpDropdown", value: true } });
            },
            onHide: () => {
                const openModalHelpDropdown = pref.dataLocal?.openModalHelpDropdown ?? false;
                if (openModalHelpDropdown) dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "openModalHelpDropdown", value: false } });
            }
        }
    ];

    const helperClose = async () => {
        dispatch({ type: 'MENU_HELPER_VISIBLE', payload: false });

        initReducers();

        try {
            let type = "";

            if (document.location.pathname === '/') type = "solicitation";
            if (document.location.pathname === '/Attendance') type = "attendant";

            await userService.SaveHelperStatus(Number(props.user.id), type);
        }
        catch (error) {
            debugger;
        }
    }

    const initReducers = () => {
        let obj = {};

        const openModalPref = pref.dataLocal?.openModalPref ?? false;
        if (openModalPref) {
            obj = { ...obj, "openModalPref": false };
        }

        const openModalPropPref = pref.dataLocal?.openModalPropPref ?? false;
        if (openModalPropPref) {
            obj = { ...obj, "openModalPropPref": false };
        }

        const openModalAvaliationPref = pref.dataLocal?.openModalAvaliationPref ?? false;
        if (openModalAvaliationPref) {
            obj = { ...obj, "openModalAvaliationPref": false };
        }

        const openClickSearch = pref.dataLocal?.openClickSearch ?? false;
        if (openClickSearch) {
            obj = { ...obj, "openClickSearch": false };
        }

        const openTemplates = pref.dataLocal?.openTemplates ?? false;
        if (openTemplates) {
            obj = { ...obj, "openTemplates": false };
        }

        const openModalPeriodFilters = pref.dataLocal?.openModalPeriodFilters ?? false;
        if (openModalPeriodFilters) {
            obj = { ...obj, "openModalPeriodFilters": false };
        }

        const openModalHelpDropdown = pref.dataLocal?.openModalHelpDropdown ?? false;
        if (openModalHelpDropdown) {
            obj = { ...obj, "openModalHelpDropdown": false };
        }

        const openLastComments = pref.dataLocal?.openLastComments ?? false;
        if (openLastComments) {
            obj = { ...obj, "openLastComments": false };
        }



        const openTemplatesAttPref = pref.dataLocal?.openTemplatesAttPref ?? false;
        if (openTemplatesAttPref) {
            obj = { ...obj, "openTemplatesAttPref": false };
        }

        const openModalAttPref = pref.dataLocal?.openModalAttPref ?? false;
        if (openModalAttPref) {
            obj = { ...obj, "openModalAttPref": false };
        }

        const openTooltipAttPref = pref.dataLocal?.openTooltipAttPref ?? false;
        if (openTooltipAttPref) {
            obj = { ...obj, "openTooltipAttPref": false };
        }

        const openTooltipCommentsPref = pref.dataLocal?.openTooltipCommentsPref ?? false;
        if (openTooltipCommentsPref) {
            obj = { ...obj, "openTooltipCommentsPref": false };
        }

        const openVincularPref = pref.dataLocal?.openVincularPref ?? false;
        if (openVincularPref) {
            obj = { ...obj, "openVincularPref": false };
        }

        const openFiltersAttPref = pref.dataLocal?.openFiltersAttPref ?? false;
        if (openFiltersAttPref) {
            obj = { ...obj, "openFiltersAttPref": false };
        }

        const openClickSearchAttPref = pref.dataLocal?.openClickSearchAttPref ?? false;
        if (openClickSearchAttPref) {
            obj = { ...obj, "openClickSearchAttPref": false };
        }

        const openMenuOptionsAttPref = pref.dataLocal?.openMenuOptionsAttPref ?? false;
        if (openMenuOptionsAttPref) {
            obj = { ...obj, "openMenuOptionsAttPref": false };
        }

        dispatch({ type: "PREF_UPDATE_MORE_LOCAL", payload: obj });
    }

    return (
        <>
            {/* {
                document.location.pathname === '/' &&
                <Helper list={solicitationHelperList} visible={menu.showHelper} onClose={() => helperClose()} onInit={initReducers} />
            }
            {
                document.location.pathname === '/Attendance' &&
                <Helper list={attendantHelperList} visible={menu.showHelper} onClose={() => helperClose()} onInit={initReducers} />
            } */}

            {
                (document.location.pathname === '/' || document.location.pathname === '/Attendance') &&
                <Helper list={(document.location.pathname === '/') ? solicitationHelperList : attendantHelperList} visible={menu.showHelper} onClose={() => helperClose()} onInit={initReducers} />
            }
        </>
    );
};

export default HelperComponent;